import { Component, EventEmitter, Input, Output } from "@angular/core";
import { Environment } from "src/app/models/environment";
import { EnvironmentService } from "src/app/services/environment.service";


@Component({
    template: ''
})
export abstract class BaseComponent {
    /** optional overwriting environment configuration (e.g. API URL,...) */
    @Input() customEnvironment!: Environment;
    /** emit an error to the parent component or subscriber */
    @Output() onError = new EventEmitter<Error>();

    env!: string;
    build!: string;

    constructor(
        protected environmentService: EnvironmentService
    ) {
        this.defineEnvironment();
    }

    defineEnvironment() {
        this.environmentService.setCustomEnvironment(this.customEnvironment);
        this.env = this.environmentService.getEnv();
        this.build = this.environmentService.getBuild();
    }
}